
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2077.842-1770a.9.9 0 00.313.693l6.113 6.113a.953.953 0 00.664.283.919.919 0 00.664-.254.845.845 0 00.264-.635.92.92 0 00-.073-.366.941.941 0 00-.2-.3l-2.07-2.109-3.529-3.21-.283.537 3.115.186h11.428a.905.905 0 00.669-.258.918.918 0 00.259-.679.887.887 0 00-.928-.928h-11.426l-3.115.186.283.547 3.525-3.226 2.073-2.107a.941.941 0 00.2-.3.92.92 0 00.073-.366.856.856 0 00-.264-.645.919.919 0 00-.664-.254.873.873 0 00-.345.072 1.209 1.209 0 00-.347.239l-6.087 6.088a.92.92 0 00-.312.693z"}})])])
          )
        }
      }
    